export function getHTTPHeaders () {
    let userObj =  getCurrentUser();
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

export function getCurrentUser () {
    return JSON.parse(localStorage.getItem('user'));
}